// src/actions/reportActions.js
import api from '../utils/api';

export const FETCH_CHILDREN_WITH_REPORT_STATUS_SUCCESS = 'FETCH_CHILDREN_WITH_REPORT_STATUS_SUCCESS';
export const CREATE_REPORT_SUCCESS = 'CREATE_REPORT_SUCCESS';
export const FETCH_REPORTS_BY_DATE_SUCCESS = 'FETCH_REPORTS_BY_DATE_SUCCESS';

export const fetchChildrenWithReportStatus = () => async (dispatch) => {
  try {
    const res = await api.get('/reports/children');
    dispatch({
      type: FETCH_CHILDREN_WITH_REPORT_STATUS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching children with report status:', error);
    // Handle error
  }
};

export const createReport = (reportData) => async (dispatch) => {
  try {
    const res = await api.post('/reports', reportData);
    dispatch({
      type: CREATE_REPORT_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.error('Error creating report:', error);
    throw error;
  }
};


export const fetchReportsByDate = (date) => async (dispatch) => {
    try {
      const res = await api.get(`/reports/date/${date}`);
      dispatch({
        type: FETCH_REPORTS_BY_DATE_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      console.error('Error fetching reports by date:', error);
      // Handle error
    }
};

export const sendGroupReports = (groupId, date) => async () => {
  try {
    const res = await api.post('/reports/send-group', { group_id: groupId, date });
    return res.data;
  } catch (error) {
    console.error('Error sending group reports:', error);
    throw error;
  }
};
